import { render, staticRenderFns } from "./ClientAccruals.vue?vue&type=template&id=70c9bab8&scoped=true"
import script from "./ClientAccruals.vue?vue&type=script&lang=js"
export * from "./ClientAccruals.vue?vue&type=script&lang=js"
import style0 from "./ClientAccruals.vue?vue&type=style&index=0&id=70c9bab8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c9bab8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VIcon,VSimpleTable,VSpacer,VTooltip})
